
























































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Overlay, Circle, Progress, Cell, CellGroup, Icon } from "vant";
import dataShare from "@/views/mall/dataShare";
import trainService from "@/service/trainService";
import roleUtils from "@/utils/roleUtils";
import { CardType, OrderStatus } from "@/model/Base";
const CardTypes = roleUtils.BuildCardTypes();
import * as _ from "lodash";
@Component({
  name: "watchOrder",
  components: {
    [Overlay.name]: Overlay,
    [Circle.name]: Circle,
    [Progress.name]: Progress,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
  },
  filters: {
    visualCardName(card: any) {
      if (card && card.CardType) {
        return CardTypes.filter((o: any) => o.value == card.CardType)[0].text;
      }
      return "--";
    },
    visualRoleName(role: any) {
      let cards = role.Cards || [];
      let card = _.find(cards, (o: any) => o.isActive) || {};
      if (card.CardType == 1298 || card.CardType == 1299 || card.CardType == 1141 || card.CardType == 1139 || card.CardType == 1297) {
        if (card.EnglishFirstName && card.EnglishLastName) {
          return `${card.EnglishFirstName}/${card.EnglishLastName}`;
        } else {
          return `${role.FirstName}/${role.LastName}`;
        }
      } else {
        return card.RoleName || role.RoleName;
      }
    },
  },
})
export default class watchOrder extends Vue {
  isShowRule = false;
  isShowProgress = false;
  percentage = 0;
  UniqueID = "";
  activated() {
    let __self = this;
    if (sessionStorage.getItem("loginOuterUserAct") == "success" && this.UniqueID) {
      sessionStorage.removeItem("loginOuterUserAct");
      setTimeout(() => {
        __self.$root.$dialog
          .confirm({
            message: "绑定账号成功,是否尝试再次占座",
            closeOnPopstate: true,
          })
          .then(() => this.rebooking(this.UniqueID))
          .catch(() => {});
      }, 500);
    }
  }
  formatDate(value: Date, format: string = this.$root.$t("mall_order_yueri1") as string) {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  rebooking(UniqueID: string) {
    this.UniqueID = UniqueID;
    trainService.rebooking(UniqueID).then(json => {
      if (json.isSucc) {
        this.startWatch(UniqueID, this);
      } else {
        this.$dialog
          .alert({
            message: json.message,
            closeOnPopstate: true,
          })
          .then(() => {});
      }
    });
  }

  executeStrategy(ClientStatusName: string, ClientOrderStatus: number, UniqueID: string) {
    let __self = this;
    this.UniqueID = UniqueID;
    if (ClientStatusName.indexOf("待确认") == -1 || ClientOrderStatus != OrderStatus.WaitConfirm) {
      this.isShowProgress = false;
    }
    if (ClientOrderStatus != OrderStatus.WaitConfirm) {
      __self.percentage = 100;
      __self.$emit("complate", true);
      return;
    }
    if (ClientStatusName.indexOf("待确认") == 0) {
      return;
    } else if (ClientStatusName.indexOf("密码错误") > -1) {
      __self.$dialog
        .alert({
          message: "已绑定12306账号或密码错误，请重新绑定",
          closeOnPopstate: true,
        })
        .then(() => {
          this.$router.push(`/mall/trainAccount?UniqueID=${UniqueID}`);
        });
    } else {
      __self.$root.$dialog
        .confirm({
          title: "占座失败，是否尝试再次占座",
          message: ClientStatusName,
          closeOnPopstate: true,
          confirmButtonText: "再次占座",
          cancelButtonText: "关闭",
        })
        .then(() => this.rebooking(this.UniqueID))
        .catch(() => {});
    }
  }

  policys!: [];
  consumers!: [];

  startWatch(UniqueID: string, orderFrame: any) {
    let __self = this;
    console.log(orderFrame);
    this.isShowProgress = true;
    this.UniqueID = UniqueID;
    if (orderFrame.policys && orderFrame.policys.length > 0) {
      this.policys = orderFrame.policys;
    }
    if (orderFrame.consumers && orderFrame.consumers.length > 0) {
      this.consumers = orderFrame.consumers;
    }
    __self.percentage = 40;
    let factor = 1;
    let StationScheduleTime = setInterval(function() {
      __self.percentage = __self.percentage + factor;
      if (__self.percentage > 45) {
        factor = 0.5;
      }
      if (__self.percentage > 65) {
        factor = 0.2;
      }
      if (__self.percentage > 85) {
        clearInterval(StationScheduleTime);
      }
    }, 200);

    let time = setInterval(() => {
      trainService.GetSimpleOrder(UniqueID).then(json => {
        let result: any = json.result;
        if (result.ClientStatusName.indexOf("待确认") == 0) {
          return;
        }
        clearInterval(time);
        this.executeStrategy(result.ClientStatusName, result.ClientOrderStatus, UniqueID);
      });
    }, 2000);
  }
}
